<template>
<div>
  <div class="flex p-4 mt-4 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
  <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
  <span class="sr-only">Info</span>
  <div>
    <span class="font-medium">与此诊所确认您的挂号预约可能需要花一些时间</span>
      <ul class="mt-1.5 ml-4 list-disc list-inside">
        <li>北美好医生平台当前还未与诊所建立自动化对接确认</li>
        <li>北美好医生平台系统将联系诊所为您确认最终预约时间</li>
        <li>北美好医生平台在得到诊所确认后，将通过短信或电话与您确认，您可联系平台或诊所随时更改您的需求</li>
    </ul>
  </div>
</div>

<div class="flex p-4 my-4 text-sm text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300 dark:border-yellow-800" role="alert">
  <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
  <span class="sr-only">Info</span>
  <div>
    <span class="font-medium">有关您的个人信息保护和平台免责声明，请您知晓：</span>

   
      <ul class="mt-1.5 ml-4 list-disc list-inside">
        <li>北美好医生为信息平台网站，致力于协助您对接优质医疗资源。北美好医生为非医疗机构，平台不提供医疗服务，不对医疗机构的医疗服务质量及医疗结果负责</li>
        <li>因平台为非医疗机构，您提供的信息在抵达医疗机构前可能不会受到适用于医疗机构的相关联法规 (如:HIPAA) 保护</li>
        <li>平台会根据行业标准对您提供给平台的信息进行保护，您向平台提供的个人信息，将仅用于平台对接医疗资源，不会用于其他用途</li>
        <li>请您在使用平台服务前，仔细阅读<a href="/policy/tou" class="underline">《北美好医生用户协议》(英文)</a></li>
        
    </ul>

  </div>
</div>
</div>
</template>

